import React, { useState } from 'react';
import Papa from 'papaparse';
import FileDropzone from './FileDropzone';
import TransactionTable from './TransactionTable';

function Bank() {
  const [transactions, setTransactions] = useState([]);
  const [statementName, setStatementName] = useState('');

  const parseCSV = (csvData) => {
    Papa.parse(csvData, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const parsedTransactions = results.data.map((row) => ({
          date: row.dateOp || '',
          description: row.label || '',
          amount: row.amount ? parseFloat(row.amount) : 0,
          category: row.category || 'Non catégorisé',
          categoryParent: row.categoryParent || '',
          supplier: row.supplierFound || '',
          comment: row.comment || '',
          account: row.accountLabel || '',
        }));
        setTransactions(parsedTransactions);
      },
      error: (error) => {
        console.error("Erreur de parsing :", error);
        alert("Erreur lors de la lecture du fichier CSV.");
      },
    });
  };

  const handleFileDrop = (csvData, fileName) => {
    setStatementName(fileName);
    parseCSV(csvData);
  };

  const sendToBackend = async () => {
    if (transactions.length === 0 || !statementName) {
      alert('Aucune transaction à envoyer ou nom de relevé manquant.');
      return;
    }

    try {
      console.log("Données envoyées :", { transactions, statementName });
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/transactions`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ transactions, statementName }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Erreur HTTP: ${response.status}`);
      }

      const data = await response.json();
      alert(data.message || 'Relevé importé avec succès !');
    } catch (error) {
      console.error('Erreur réseau :', error);
      alert(`Erreur réseau : ${error.message}`);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>Banque</h1>
      <p>Importez votre relevé bancaire au format CSV.</p>
      <FileDropzone onFileDrop={handleFileDrop} />
      {transactions.length > 0 && (
        <>
          <button
            onClick={sendToBackend}
            style={{
              padding: '10px 15px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginBottom: '20px',
            }}
          >
            Enregistrer les transactions
          </button>
          <TransactionTable transactions={transactions} />
        </>
      )}
    </div>
  );
}

export default Bank;
